import { LuFileText } from 'react-icons/lu';
import Drawer from '../Drawer/Drawer';
import StatusBadge from '../StatusBadge/StatusBadge';
import styles from './ApplicationDrawer.module.css';

function Field({ label, value, fullWidth }) {
  return (
    <div className={fullWidth ? styles.gridFull : ''}>
      <p className={styles.fieldLabel}>{label}</p>
      <p className={styles.fieldValue}>{value}</p>
    </div>
  );
}

export default function ApplicationDrawer({ partner, onClose, onApprove, onReject }) {
  return (
    <Drawer
      isOpen={!!partner}
      title="Application details"
      onClose={onClose}
      footer={
        <>
          <button className={styles.btnReject} onClick={() => onReject && onReject(partner)}>Reject partner</button>
          <button className={styles.btnApprove} onClick={() => onApprove && onApprove(partner)}>Approve partner</button>
        </>
      }
    >
      {partner && (
        <>
          {/* Application details card */}
          <div className={styles.card}>
            <div className={styles.grid}>
              <Field label="Company name"        value={partner.company} />
              <Field label="Registration number" value={partner.registrationNumber || 'GH-2023-88821'} />
              <Field label="Partner Type"        value={partner.type} />
              <Field label="Location"            value={partner.location || 'Accra, Ghana'} />
              <Field label="Address"             value={partner.address || '23 Independence Ave'} />
              <Field label="Applied date"        value={partner.applied} />
              <div>
                <p className={styles.fieldLabel}>Status</p>
                <StatusBadge status={partner.status} />
              </div>
            </div>
          </div>

          {/* Contact card */}
          <div className={styles.card}>
            <p className={styles.cardTitle}>Contact</p>
            <div className={styles.grid}>
              <Field label="Name"     value={partner.contactName} />
              <Field label="Position" value={partner.position || 'Sales Manager'} />
              <Field label="Phone"    value={partner.phone || '+233 000 000 0000'} />
              <Field label="Email"    value={partner.contactEmail} fullWidth />
            </div>
          </div>

          {/* Submitted documents card */}
          <div className={styles.card}>
            <p className={styles.cardTitle}>Submitted documents</p>
            {(partner.documents || ['weight_cert_2024.pdf', 'weight_cert_2024.pdf']).map((doc, i) => (
              <div key={i} className={styles.docRow}>
                <div className={styles.docLeft}>
                  <LuFileText size={18} className={styles.docIcon} />
                  <div>
                    <p className={styles.docName}>{doc}</p>
                    <p className={styles.docMeta}>2.3 MB • Uploaded</p>
                  </div>
                </div>
                <button className={styles.viewLink}>View</button>
              </div>
            ))}
          </div>
        </>
      )}
    </Drawer>
  );
}
